import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const getAllProgramTypes = async (data) =>
  await api.get(`getAllTrainingTypes/${data.usertype}/${data.language}`);

export const getAllModules = async (data) =>
  await api.get(
    `getAllModules/${data.trainingType}/${data.usertype}/${data.language}`
  );

export const getAllsubModules = async (data) =>
  await api.get(
    `getAllSubmodulesByModuleId/${data.trainingType}/${data.usertype}/${data.language}/${data.moduleid}`
  );

export const getAllTopics = async (data) =>
  await api.get(
    `getAllTopicsBySubmoduleId/${data.usertype}/${data.trainingType}/${data.language}/${data.moduleid}/${data.submoduleid}`
  );

export const getAllData = async (data) =>
  await api.get(`getMasterTchTrainingAssignment/${data.topicId}`);

export const updateassignmentquestion = async (reqbody) => {
  //const id = reqbody._id;
  //const body = reqbody.body;
  await api.put("updateMasterTchTrainingAssignment", reqbody);
};

export const deleteAssignmentData = async (data) => {
  await api.delete(`deleteMasterTchTrainingAssignment/${data.topicId}`);
};

export const createAssignmentData = async (data) => {
  await api.post(`saveMasterTchTrainingAssignment`, data);
};
